import type { BetterstartIntegrationDefinition } from '@integration-engine/types.js'

export const resendIntegration: BetterstartIntegrationDefinition = {
  id: 'resend',
  title: 'Resend',
  description: 'Email delivery for auth and form notifications',
  kind: 'email',
  version: '1.0.1',
  dependencies: [],
  conflicts: [],
  files: [
    {
      outputPath: 'lib/actions/resend/provider.ts',
      templatePath: 'actions/resend.ts'
    }
  ],
  packageDependencies: ['resend'],
  devDependencies: [],
  capabilities: {
    emailProvider: {
      provider: 'resend',
      importPath: '@admin/actions/resend/provider',
      exportName: 'resendEmailProvider'
    }
  },
  envSections: [
    {
      header: 'Email (Resend)',
      vars: [
        { key: 'BETTERSTART_RESEND_API_KEY', value: '' },
        { key: 'BETTERSTART_EMAIL_FROM', value: 'noreply@yourdomain.com' }
      ]
    }
  ],
  configure: 'resend'
}
